import { AxiosRequestConfig } from 'axios'

const getMembershipPrizes = (membershipId: number): AxiosRequestConfig => ({
  url: `/memberships/${membershipId}/prizes`,
  method: 'GET',
})

const getMembershipCoupons = (membershipId: number): AxiosRequestConfig => ({
  url: `/memberships/${membershipId}/coupons`,
  method: 'GET',
})

export { getMembershipPrizes, getMembershipCoupons }
